import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';
import Swal from 'sweetalert2';
import { forkJoin } from 'rxjs';

export function ageValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;
  const birthDate = new Date(control.value);
  if (isNaN(birthDate.getTime())) return { invalidDate: true };
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const mDiff = today.getMonth() - birthDate.getMonth();
  if (mDiff < 0 || (mDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age < 18 ? { underAge: true } : null;
}

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss'],
})
export class MyProfileComponent implements OnInit {
  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (!target.closest('.custom-dropdown')) {
      this.showGenderList = false;
      this.showLanguageList = false;
      this.showPersonalDropdown = '';

      this.showProfessionalDropdown = '';

      this.showReligionDropdown = '';
      this.showLocationDropdown = '';
    }
  }
  activeTab: string = 'basic';
  loading: boolean = true;
  profileData: any = {};
  galleryPhotos: string[] = [];
  galleryImagesBase64: { [key: string]: string } = {};
  avatarPreview: string | null = null;
  selectedAvatarFile: File | null = null;
  defaultAvatarUrl = 'assets/images/user/unnamed.jpg';

  basicForm!: FormGroup;
  personalForm!: FormGroup;
  professionalForm!: FormGroup;
  religionForm!: FormGroup;
  locationForm!: FormGroup;

  // Master Data
  heightValues: number[] = [];
  weightValues: number[] = [];
  cities: any[] = [];
  districts: any[] = [];
  states: any[] = [];
  allStates: any[] = [];
  allDistricts: any[] = [];
  allCities: any[] = [];
  countries: any[] = [];
  educations: any[] = [];
  higherEducations: any[] = [];
  occupations: any[] = [];
  employmentTypes: any[] = [];
  religions: any[] = [];
  castes: any[] = [];
  subcastes: any[] = [];
  languages: any[] = [];
  selectedLanguageName: string = '';

  filteredLanguages: any[] = [];
  filteredPersonalList: any[] = [];
  personalSearchText: string = '';

  filteredHeight: any[] = [];
  filteredWeight: any[] = [];
  filteredEducation: any[] = [];
  filteredHigherEducation: any[] = [];
  filteredEmployment: any[] = [];
  filteredOccupation: any[] = [];
  filteredIncome: any[] = [];
  selectedReligion = '';
  selectedCaste = '';
  selectedSubCaste = '';
  selectedGothram = '';
  selectedDosham = '';

  showReligionDropdown = '';

  filteredReligion: any[] = [];
  filteredCaste: any[] = [];
  filteredSubCaste: any[] = [];
  filteredGothram: any[] = [];
  filteredDosham: any[] = [];
  filteredNatchra: any[] = [];
  filteredRasi: any[] = [];
  selectedCountry = '';
  selectedState = '';
  selectedDistrict = '';
  selectedCity = '';

  showLocationDropdown = '';

  filteredCountry: any[] = [];
  filteredState: any[] = [];
  filteredDistrict: any[] = [];
  filteredCity: any[] = [];

  doshamList = [
    { name: 'Yes', value: 'Yes' },
    { name: 'No', value: 'No' },
    { name: "Don't Know", value: "Don't Know" },
  ];

  showProfessionalDropdown: string = '';

  selectedEducation: string = '';
  selectedHigherEducation: string = '';
  selectedEmployment: string = '';
  selectedOccupation: string = '';
  selectedIncome: string = '';

  additionalIncomeSources = ['Rental Income', 'Agriculture', 'Business', 'Investments', 'Freelancing', 'Other (Specify / Type Custom)'];

  showLanguageList: boolean = false;
  // citizenships: any[] = [];
  incomes: any[] = [];
  gothrams: any[] = [];
  natchras: any[] = [];
  rasis: any[] = [];
  selectedNatchra: string = '';
  selectedRasi: string = '';
  genderList = [
    { name: 'Male', value: 'Male' },
    { name: 'Female', value: 'Female' },
  ];
  maritalList = [
    { name: 'Never Married', value: 'Never Married' },
    { name: 'Widowed', value: 'Widowed' },
    { name: 'Divorced', value: 'Divorced' },
  ];

  physicalStatusList = [
    { name: 'Normal', value: 'Normal' },
    { name: 'Physically Challenged', value: 'Physically Challenged' },
  ];

  foodList = [
    { name: 'Vegetarian', value: 'Vegetarian' },
    { name: 'Non-Vegetarian', value: 'Non-Vegetarian' },
    { name: 'Eggetarian', value: 'Eggtarian' },
  ];

  yesNoList = [
    { name: 'No', value: 'No' },
    { name: 'Yes', value: 'Yes' },
  ];

  bodyTypeList = [
    { name: 'Slim', value: 'Slim' },
    { name: 'Average', value: 'Average' },
    { name: 'Athletic', value: 'Athletic' },
    { name: 'Heavy', value: 'Heavy' },
  ];

  selectedMarital = '';
  selectedPhysical = '';
  selectedFood = '';
  selectedSmoking = '';
  selectedDrinking = '';
  selectedBody = '';
  selectedHeight: string = '';
  selectedWeight: string = '';

  showPersonalDropdown: string = '';

  selectedGender: string = '';

  filteredGenderList: any[] = [];

  showGenderList: boolean = false;
  maxDate: string = '';

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiServiceService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.heightValues = Array.from({ length: 191 }, (_, i) => i + 60); // 60 to 250
    this.weightValues = Array.from({ length: 111 }, (_, i) => i + 40); // 40 to 150
  }

  ngOnInit(): void {
    const today = new Date();
    const maxYear = today.getFullYear() - 18;
    this.maxDate = new Date(maxYear, today.getMonth(), today.getDate()).toISOString().split('T')[0];
    this.initForms();
    this.loadMasterData();
    this.route.queryParams.subscribe(params => {
      if (params['tab']) {
        this.activeTab = params['tab'];
      }
    });
  }

  initForms() {
    this.basicForm = this.formBuilder.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      gender: ['', Validators.required],
      date_of_birth: ['', [Validators.required, ageValidator]],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      mother_lang_id: ['', Validators.required],
    });

    this.personalForm = this.formBuilder.group({
      marital_status: ['', Validators.required],
      height: ['', Validators.required],
      weight: ['', Validators.required],
      physical_status: ['', Validators.required],
      food: ['', Validators.required],
      body_type: [''],
      blood_group: [''],
      smoking: [''],
      drinking: [''],
    });

    this.professionalForm = this.formBuilder.group({
      education_id: ['', Validators.required],
      education_detail: [''],
      higher_education_id: [''],
      employmentype_id: ['', Validators.required],
      occupation_id: ['', Validators.required],
      occupation_detail: [''],
      income_id: ['', Validators.required],
      work_city_id: [''],
      work_state_id: [''],
      work_country_id: [''],
      work_zipcode: [''],
      additional_income_source: [''],
      additional_annual_income: ['', [Validators.pattern('^[1-9][0-9]*$')]]
    });

    this.professionalForm.get('additional_income_source')?.valueChanges.subscribe(val => {
      const annualCtrl = this.professionalForm.get('additional_annual_income');
      if (val && val.trim() !== '') {
        annualCtrl?.setValidators([Validators.required, Validators.pattern('^[1-9][0-9]*$')]);
      } else {
        annualCtrl?.setValidators([Validators.pattern('^[1-9][0-9]*$')]);
      }
      annualCtrl?.updateValueAndValidity({ emitEvent: false });
    });

    this.religionForm = this.formBuilder.group({
      religion_id: ['', Validators.required],
      caste_id: ['', Validators.required],
      sub_caste_id: [''],
      gothrm_id: [''],
      natchr_id: [''],
      rasi_id: [''],
      dosham: [''],
    });

    this.locationForm = this.formBuilder.group({
      city_id: ['', Validators.required],
      dist_id: ['', Validators.required],
      state_id: ['', Validators.required],
      country_id: ['', Validators.required],
      address1: [''],
    });
  }

  onMobileInput(event: any): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9]/g, '');
    if (value.length > 10) {
      value = value.slice(0, 10);
    }
    this.basicForm.get('mobile')?.setValue(value);
  }

  loadMasterData() {
    this.loading = true;
    forkJoin([
      this.apiService.getCity(),
      this.apiService.getDistrict(),
      this.apiService.getState(),
      this.apiService.getCountry(),
      this.apiService.getEducation(),
      this.apiService.getHigherEducation(),
      this.apiService.getOccupation(),
      this.apiService.getEmploymentType(),
      this.apiService.getReligions(),
      this.apiService.getCastes(),
      this.apiService.getSubCastes(),
      this.apiService.getLanguages(),
      this.apiService.getCitizens(),
      this.apiService.getIncome(),
      this.apiService.getGothrams(),
      this.apiService.getNatchra(),
      this.apiService.getRasi(),
    ]).subscribe({
      next: ([
        cityRes,
        districtRes,
        stateRes,
        countryRes,
        eduRes,
        highEduRes,
        occRes,
        empRes,
        relRes,
        casteRes,
        subCasteRes,
        langRes,
        citRes,
        incRes,
        gothramRes,
        natchraRes,
        rasiRes,
      ]) => {
        this.cities = cityRes?.data || [];
        this.districts = districtRes?.data || [];
        this.states = stateRes?.data || [];
        this.countries = countryRes?.data || [];
        console.log('COUNTRY SAMPLE', this.countries[0]);
        console.log('STATE SAMPLE', this.states[0]);
        console.log('DISTRICT SAMPLE', this.districts[0]);
        console.log('CITY SAMPLE', this.cities[0]);
        this.allStates = [...this.states];
        this.allDistricts = [...this.districts];
        this.allCities = [...this.cities];
        this.educations = eduRes?.data || [];
        this.higherEducations = highEduRes?.data || [];
        this.occupations = occRes?.data || [];
        this.employmentTypes = empRes?.data || [];
        this.religions = relRes?.data || [];
        this.castes = casteRes?.data || [];
        this.subcastes = subCasteRes?.data || [];
        this.languages = langRes?.data || [];
        // this.citizenships = citRes?.data || [];
        this.incomes = incRes?.data || [];
        this.gothrams = gothramRes?.data || [];
        this.natchras = natchraRes?.data || [];
        this.rasis = rasiRes?.data || [];

        this.loadProfileData();
      },
      error: (err) => {
        console.error('Error loading master data', err);
        this.loading = false;
        Swal.fire(
          'Error',
          'Failed to load master data. Please refresh.',
          'error',
        );
      },
    });
  }

  loadProfileData() {
    const sessionToken = localStorage.getItem('sessionToken');
    const profileId = localStorage.getItem('profileId');

    if (!sessionToken || !profileId) {
      this.router.navigate(['/login']);
      return;
    }

    this.apiService.getEditDetails(sessionToken, profileId).subscribe({
      next: (res: any) => {
        if (res && res.data) {
          this.profileData = res.data;
          this.galleryPhotos = this.profileData.personal_info?.gallery_photos || [];
          this.loadAvatarPreview();
          this.loadGalleryImages();
          this.patchForms();
        }
        this.loading = false;
        const tabParam = this.route.snapshot.queryParams['tab'];
        if (tabParam) {
          this.activeTab = tabParam;
        }
      },
      error: (err) => {
        console.error('Error loading profile data', err);
        this.loading = false;
        Swal.fire('Error', 'Failed to load profile details.', 'error');
      },
    });
  }

  patchForms() {
    const data = this.profileData;

    // Helper to safely extract _id from populated objects or use the string value
    const getId = (field: any) => (field?._id ? field._id : field || '');

    if (data.basic_info) {
      this.basicForm.patchValue({
        first_name: data.basic_info.first_name || '',
        last_name: data.basic_info.last_name || '',
        gender: data.basic_info.gender || '',

        date_of_birth: data.basic_info.date_of_birth
          ? this.formatDate(data.basic_info.date_of_birth)
          : '',
        email: data.basic_info.email || '',
        mobile: data.basic_info.mobile || '',
        mother_lang_id: getId(data.basic_info.mother_lang_id),
      });
      this.selectedGender = data.basic_info.gender || '';
      this.filteredGenderList = this.genderList;
      const langId = getId(data.basic_info.mother_lang_id);

      const selectedLang = this.languages.find((l: any) => l._id === langId);

      this.selectedLanguageName = selectedLang ? selectedLang.language_nme : '';

      this.filteredLanguages = this.languages;
    }

    if (data.personal_info) {
      this.personalForm.patchValue({
        marital_status: data.personal_info.marital_status || '',
        height: data.personal_info.height || '',
        weight: data.personal_info.weight || '',
        physical_status: data.personal_info.physical_status || '',
        food: data.personal_info.food || '',
        body_type: data.personal_info.body_type || '',
        blood_group: data.personal_info.blood_group || '',
        smoking: data.personal_info.smoking || '',
        drinking: data.personal_info.drinking || '',
      });
      this.selectedMarital = data.personal_info.marital_status || '';

      this.selectedPhysical = data.personal_info.physical_status || '';

      this.selectedFood = data.personal_info.food || '';

      this.selectedSmoking = data.personal_info.smoking || '';

      this.selectedDrinking = data.personal_info.drinking || '';
      this.selectedHeight = data.personal_info.height || '';

      this.selectedWeight = data.personal_info.weight || '';

      this.selectedBody = data.personal_info.body_type || '';
    }

    if (data.professional_info) {
      this.professionalForm.patchValue({
        education_id: getId(data.professional_info.education_id),
        education_detail: data.professional_info.education_detail || '',
        higher_education_id: getId(data.professional_info.higher_education_id),
        employmentype_id: getId(data.professional_info.employmentype_id),
        occupation_id: getId(data.professional_info.occupation_id),
        occupation_detail: data.professional_info.occupation_detail || '',
        income_id: getId(data.professional_info.income_id),
        work_city_id: getId(data.professional_info.work_city_id),
        work_state_id: getId(data.professional_info.work_state_id),
        work_country_id: getId(data.professional_info.work_country_id),
        work_zipcode: data.professional_info.work_zipcode || '',
        additional_income_source: data.professional_info.additional_income_source || '',
        additional_annual_income: data.professional_info.additional_annual_income ? Number(data.professional_info.additional_annual_income) : ''
      });
      const edu = this.educations.find(
        (e: any) => e._id === getId(data.professional_info.education_id),
      );

      this.selectedEducation = edu ? edu.education_nme : '';

      const high = this.higherEducations.find(
        (e: any) => e._id === getId(data.professional_info.higher_education_id),
      );

      this.selectedHigherEducation = high ? high.highereducation_nme : '';

      const emp = this.employmentTypes.find(
        (e: any) => e._id === getId(data.professional_info.employmentype_id),
      );

      this.selectedEmployment = emp ? emp.employment_type_nme : '';

      const occ = this.occupations.find(
        (e: any) => e._id === getId(data.professional_info.occupation_id),
      );

      this.selectedOccupation = occ ? occ.occupation_nme : '';

      const inc = this.incomes.find(
        (e: any) => e._id === getId(data.professional_info.income_id),
      );

      this.selectedIncome = inc ? inc.income_nme : '';
    }

    if (data.religion_info) {
      this.religionForm.patchValue({
        religion_id: getId(data.religion_info.religion_id),
        caste_id: getId(data.religion_info.caste_id),
        sub_caste_id: getId(data.religion_info.sub_caste_id),
        gothrm_id: getId(data.religion_info.gothrm_id),
        natchr_id: getId(data.religion_info.natchr_id),
        rasi_id: getId(data.religion_info.rasi_id),
        dosham: data.religion_info.dosham || '',
      });
      this.selectedReligion =
        this.religions.find(
          (x: any) => x._id === getId(data.religion_info.religion_id),
        )?.religion_nme || '';

      this.selectedCaste =
        this.castes.find(
          (x: any) => x._id === getId(data.religion_info.caste_id),
        )?.caste_nme || '';

      this.selectedSubCaste =
        this.subcastes.find(
          (x: any) => x._id === getId(data.religion_info.sub_caste_id),
        )?.subcaste_nme || '';

      this.selectedGothram =
        this.gothrams.find(
          (x: any) => x._id === getId(data.religion_info.gothrm_id),
        )?.gothram_nme || '';

      this.selectedDosham = data.religion_info.dosham || '';
      this.selectedNatchra = this.natchras.find((x:any)=> x._id === getId(data.religion_info.natchr_id))?.natchr_nme || '';
      this.selectedRasi = this.rasis.find((x:any)=> x._id === getId(data.religion_info.rasi_id))?.rasi_nme || '';
      
      this.updateAstrologyValidators();
    }

    if (data.residing_location || data.professional_info) {
      const loc = data.residing_location || {};
      const work = data.professional_info || {};
      this.locationForm.patchValue({
        city_id: getId(loc.city_id || work.work_city_id),
        dist_id: getId(loc.dist_id || work.work_dist_id),
        state_id: getId(loc.state_id || work.work_state_id),
        country_id: getId(loc.country_id || work.work_country_id),
        address1: loc.address1 || '',
      });
      this.selectedCountry =
        this.countries.find(
          (x: any) => x._id === getId(loc.country_id || work.work_country_id),
        )?.name_0 || '';

      this.selectedState =
        this.states.find(
          (x: any) => x._id === getId(loc.state_id || work.work_state_id),
        )?.name_1 || '';

      this.selectedDistrict =
        this.districts.find(
          (x: any) => x._id === getId(loc.dist_id || work.work_dist_id),
        )?.name_2 || '';

      this.selectedCity =
        this.cities.find(
          (x: any) => x._id === getId(loc.city_id || work.work_city_id),
        )?.city_nme || '';
    }
  }

  formatDate(dateString: string): string {
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return '';
    const month = '' + (d.getMonth() + 1);
    const day = '' + d.getDate();
    const year = d.getFullYear();
    return [year, month.padStart(2, '0'), day.padStart(2, '0')].join('-');
  }

  setTab(tab: string) {
    this.activeTab = tab;
  }
  openGenderDropdown(){

 if(this.showGenderList){
   this.showGenderList=false;
   return;
 }

 this.filteredGenderList=this.genderList;
 this.showGenderList=true;

}

  searchGender(event: any) {
    const searchText = event.target.value.toLowerCase();

    this.filteredGenderList = this.genderList.filter((item: any) =>
      item.name.toLowerCase().includes(searchText),
    );

    this.showGenderList = true;
  }

  selectGender(gender: any) {
    this.selectedGender = gender.name;

    this.basicForm.patchValue({
      gender: gender.value,
    });

    this.showGenderList = false;

    this.filteredGenderList = this.genderList;
  }
  openLanguageDropdown(){

 if(this.showLanguageList){
   this.showLanguageList=false;
   return;
 }

 this.filteredLanguages=this.languages;
 this.showLanguageList=true;

}

  searchLanguage(event: any) {
    const searchText = event.target.value.toLowerCase();

    this.filteredLanguages = this.languages.filter((lang: any) =>
      lang.language_nme.toLowerCase().includes(searchText),
    );

    this.showLanguageList = true;
  }

  selectLanguage(lang: any) {
    this.selectedLanguageName = lang.language_nme;

    this.basicForm.patchValue({
      mother_lang_id: lang._id,
    });

    this.showLanguageList = false;

    this.filteredLanguages = this.languages;
  }
 openPersonalDropdown(type:string){

 if(this.showPersonalDropdown===type){
    this.showPersonalDropdown='';
    return;
 }

 this.showPersonalDropdown=type;

    this.personalSearchText = '';

    if (type === 'marital') {
      this.filteredPersonalList = [...this.maritalList];
    }

    if (type === 'physical') {
      this.filteredPersonalList = [...this.physicalStatusList];
    }

    if (type === 'food') {
      this.filteredPersonalList = [...this.foodList];
    }

    if (type === 'smoking' || type === 'drinking') {
      this.filteredPersonalList = [...this.yesNoList];
    }

    if (type === 'body') {
      this.filteredPersonalList = [...this.bodyTypeList];
    }

    if (type === 'height') {
      this.filteredHeight = this.heightValues.map((x) => ({
        name: x,
        value: x,
      }));
    }

    if (type === 'weight') {
      this.filteredWeight = this.weightValues.map((x) => ({
        name: x,
        value: x,
      }));
    }
  }
  openProfessionalDropdown(type:string){

 if(this.showProfessionalDropdown===type){
    this.showProfessionalDropdown='';
    return;
 }

 this.showProfessionalDropdown=type;

    if (type === 'education') {
      this.filteredEducation = [...this.educations];
    }

    if (type === 'higher') {
      this.filteredHigherEducation = [...this.higherEducations];
    }

    if (type === 'employment') {
      this.filteredEmployment = [...this.employmentTypes];
    }

    if (type === 'occupation') {
      this.filteredOccupation = [...this.occupations];
    }

    if (type === 'income') {
      this.filteredIncome = [...this.incomes];
    }
  }
  searchProfessional(event: any, type: string) {
    const text = event.target.value.toLowerCase();

    if (type === 'education') {
      this.filteredEducation = this.educations.filter((item: any) =>
        item.education_nme.toLowerCase().includes(text),
      );
    }

    if (type === 'higher') {
      this.filteredHigherEducation = this.higherEducations.filter((item: any) =>
        item.highereducation_nme.toLowerCase().includes(text),
      );
    }

    if (type === 'employment') {
      this.filteredEmployment = this.employmentTypes.filter((item: any) =>
        item.employment_type_nme.toLowerCase().includes(text),
      );
    }

    if (type === 'occupation') {
      this.filteredOccupation = this.occupations.filter((item: any) =>
        item.occupation_nme.toLowerCase().includes(text),
      );
    }

    if (type === 'income') {
      this.filteredIncome = this.incomes.filter((item: any) =>
        item.income_nme.toLowerCase().includes(text),
      );
    }
  }

  searchPersonal(event: any) {
    const text = event.target.value.toLowerCase();

    if (this.showPersonalDropdown === 'height') {
      this.filteredHeight = this.heightValues
        .map((x) => ({
          name: x,
          value: x,
        }))
        .filter((item: any) => String(item.name).includes(text));

      return;
    }

    if (this.showPersonalDropdown === 'weight') {
      this.filteredWeight = this.weightValues
        .map((x) => ({
          name: x,
          value: x,
        }))
        .filter((item: any) => String(item.name).includes(text));

      return;
    }

    this.filteredPersonalList = this.filteredPersonalList.filter((item: any) =>
      item.name.toLowerCase().includes(text),
    );
  }
  selectPersonal(item: any, control: string) {
    if (control === 'marital_status') {
      this.selectedMarital = item.name;
    }

    if (control === 'physical_status') {
      this.selectedPhysical = item.name;
    }

    if (control === 'food') {
      this.selectedFood = item.name;
    }

    if (control === 'smoking') {
      this.selectedSmoking = item.name;
    }

    if (control === 'drinking') {
      this.selectedDrinking = item.name;
    }

    if (control === 'body_type') {
      this.selectedBody = item.name;
    }
    if (control === 'height') {
      this.selectedHeight = item.name;
    }

    if (control === 'weight') {
      this.selectedWeight = item.name;
    }

    this.personalForm.patchValue({
      [control]: item.value,
    });

    this.showPersonalDropdown = '';
  }
  selectProfessional(item: any, type: string) {
    if (type === 'education') {
      this.selectedEducation = item.education_nme;

      this.professionalForm.patchValue({
        education_id: item._id,
      });
    }

    if (type === 'higher') {
      this.selectedHigherEducation = item.highereducation_nme;

      this.professionalForm.patchValue({
        higher_education_id: item._id,
      });
    }

    if (type === 'employment') {
      this.selectedEmployment = item.employment_type_nme;

      this.professionalForm.patchValue({
        employmentype_id: item._id,
      });
    }

    if (type === 'occupation') {
      this.selectedOccupation = item.occupation_nme;

      this.professionalForm.patchValue({
        occupation_id: item._id,
      });
    }

    if (type === 'income') {
      this.selectedIncome = item.income_nme;

      this.professionalForm.patchValue({
        income_id: item._id,
      });
    }

    this.showProfessionalDropdown = '';
  }

  isCustomAddIncome(val: string | null | undefined): boolean {
    if (!val) return false;
    const standard = ['Rental Income', 'Agriculture', 'Business', 'Investments', 'Freelancing'];
    return !standard.includes(val);
  }

  onCustomAddIncomeChange(event: any): void {
    const customVal = event.target.value;
    this.professionalForm.patchValue({
      additional_income_source: customVal || 'Other (Specify / Type Custom)'
    }, { emitEvent: true });
  }

  selectAddIncomeSource(src: string): void {
    if (src === 'Other (Specify / Type Custom)' || src === 'Other') {
      this.professionalForm.patchValue({ additional_income_source: 'Other (Specify / Type Custom)' });
    } else {
      this.professionalForm.patchValue({ additional_income_source: src });
    }
    if (!src) {
      this.professionalForm.patchValue({ additional_annual_income: '' });
    }
    this.showProfessionalDropdown = '';
  }
  openReligionDropdown(type:string){

 if(this.showReligionDropdown===type){
    this.showReligionDropdown='';
    return;
 }

 this.showReligionDropdown=type;

    if (type === 'religion') {
      this.filteredReligion = this.religions;
    }

    if (type === 'caste') {

  const religionId = this.religionForm.value.religion_id;

  if (!religionId) {
    Swal.fire('Select Religion', 'Please select religion first', 'warning');
    return;
  }

  this.filteredCaste = this.castes.filter(
    (c: any) => c.religion_id === religionId
  );
}

if (type === 'subcaste') {

  const casteId = this.religionForm.value.caste_id;

  if (!casteId) {
    Swal.fire('Select Caste', 'Please select caste first', 'warning');
    return;
  }

  this.filteredSubCaste = this.subcastes.filter(
    (s: any) => s.caste_id === casteId
  );
}

    if (type === 'gothram') {
      this.filteredGothram = this.gothrams;
    }

    if (type === 'dosham') {
      this.filteredDosham = this.doshamList;
    }
    if (type === 'natchr') {
      this.filteredNatchra = this.natchras;
    }

    if (type === 'raasi') {
      this.filteredRasi = this.rasis;
    }
  }

  searchReligion(event: any, type: string) {
    let text = event.target.value.toLowerCase();

    if (type === 'religion') {
      this.filteredReligion = this.religions.filter((x: any) =>
        x.religion_nme.toLowerCase().includes(text),
      );
    }

    if (type === 'caste') {
      this.filteredCaste = this.castes.filter((x: any) =>
        x.caste_nme.toLowerCase().includes(text),
      );
    }

    if (type === 'subcaste') {
      this.filteredSubCaste = this.subcastes.filter((x: any) =>
        x.subcaste_nme.toLowerCase().includes(text),
      );
    }

    if (type === 'gothram') {
      this.filteredGothram = this.gothrams.filter((x: any) =>
        x.gothram_nme.toLowerCase().includes(text),
      );
    }

    if (type === 'dosham') {
      this.filteredDosham = this.doshamList.filter((x: any) =>
        x.name.toLowerCase().includes(text),
      );
    }
    if (type === 'natchr') {
      this.filteredNatchra = this.natchras.filter((x: any) =>
        (x.natchr_nme || x.natchr_name || '').toLowerCase().includes(text),
      );
    }

    if (type === 'raasi') {
      this.filteredRasi = this.rasis.filter((x: any) =>
        (x.rasi_nme || x.rasi_name || '').toLowerCase().includes(text),
      );
    }
  }

  selectReligion(item: any, type: string) {

  if (type === 'religion') {

    this.selectedReligion = item.religion_nme;

    this.religionForm.patchValue({
      religion_id: item._id,
      caste_id: '',
      sub_caste_id: '',
    });

    this.selectedCaste = '';
    this.selectedSubCaste = '';

    this.filteredCaste = this.castes.filter(
      (c: any) => c.religion_id === item._id
    );

    this.filteredSubCaste = [];
    this.updateAstrologyValidators();

    if (this.isNonReligious()) {
      this.selectedCaste = '';
      this.selectedSubCaste = '';
      this.selectedGothram = '';
      this.selectedDosham = '';
      this.religionForm.patchValue({
        caste_id: null,
        sub_caste_id: null,
        gothrm_id: null,
        dosham: 'Not Applicable'
      });
    }
  }

  else if (type === 'caste') {

    this.selectedCaste = item.caste_nme;

    this.religionForm.patchValue({
      caste_id: item._id,
      sub_caste_id: '',
    });

    this.selectedSubCaste = '';

    this.filteredSubCaste = this.subcastes.filter(
      (s: any) => s.caste_id === item._id
    );
  }

  else if (type === 'subcaste') {

    this.selectedSubCaste = item.subcaste_nme;

    this.religionForm.patchValue({
      sub_caste_id: item._id,
    });
  }

  else if (type === 'gothram') {

    this.selectedGothram = item.gothram_nme;

    this.religionForm.patchValue({
      gothrm_id: item._id,
    });
  }

  else if (type === 'natchr') {
    this.selectedNatchra = item.natchr_nme || item.natchr_name || '';
    this.religionForm.patchValue({ natchr_id: item._id });
  }

  else if (type === 'raasi') {
    this.selectedRasi = item.rasi_nme || item.rasi_name || '';
    this.religionForm.patchValue({ rasi_id: item._id });
  }

  else if (type === 'dosham') {

    this.selectedDosham = item.name;

    this.religionForm.patchValue({
      dosham: item.value,
    });
  }

  this.showReligionDropdown = '';
}

   
  openLocationDropdown(type:string){

 if(this.showLocationDropdown===type){
    this.showLocationDropdown='';
    return;
 }

 this.showLocationDropdown=type;

    if (type === 'country') {
      this.filteredCountry = this.countries;
    }

    if (type === 'state') {
      if (!this.locationForm.value.country_id) {
        Swal.fire('Select Country', 'First select country', 'warning');
        return;
      }

      this.filteredState = this.allStates.filter(
        (x) => x.country_id === this.getSelectedCountryId(),
      );
    }

    if (type === 'district') {
      if (!this.locationForm.value.state_id) {
        Swal.fire('Select State', 'First select state', 'warning');
        return;
      }

      this.filteredDistrict = this.allDistricts.filter(
        (x) => x.state_id === this.getSelectedStateId(),
      );
    }

    if (type === 'city') {
      if (!this.locationForm.value.dist_id) {
        Swal.fire('Select District', 'First select district', 'warning');
        return;
      }

      const district = this.allDistricts.find(
        (x) => x._id === this.locationForm.value.dist_id,
      );

      this.filteredCity = this.allCities.filter(
        (x) => x.id_2 === district?.id_2,
      );
    }
  }

  searchLocation(event: any, type: string) {
    let text = event.target.value.toLowerCase();

    if (type === 'country') {
      this.filteredCountry = this.countries.filter((x: any) =>
        x.name_0.toLowerCase().includes(text),
      );
    }

    if (type === 'state') {
      this.filteredState = this.states.filter((x: any) =>
        x.name_1.toLowerCase().includes(text),
      );
    }

    if (type === 'district') {
      this.filteredDistrict = this.districts.filter((x: any) =>
        x.name_2.toLowerCase().includes(text),
      );
    }

    if (type === 'city') {
      this.filteredCity = this.cities.filter((x: any) =>
        x.city_nme.toLowerCase().includes(text),
      );
    }
  }
  getSelectedCountryId(){

  const country = this.countries.find(
    (x:any)=> x._id === this.locationForm.value.country_id
  );

  return country?.country_id;

}



getSelectedStateId(){

  const state = this.allStates.find(
    (x:any)=> x._id === this.locationForm.value.state_id
  );

  return state?.state_id;

}

  selectLocation(item: any, type: string) {
    if (type === 'country') {
      this.selectedCountry = item.name_0;

      this.locationForm.patchValue({
        country_id: item._id,
        state_id: '',
        dist_id: '',
        city_id: '',
      });

      // filter states based on country

      this.filteredState = this.allStates.filter(
(state:any)=> state.country_id === item.country_id
);


this.filteredDistrict=[];
this.filteredCity=[];

      this.selectedState = '';

      this.selectedDistrict = '';

      this.selectedCity = '';
    }

    if (type === 'state') {
      this.selectedState = item.name_1;

      this.locationForm.patchValue({
        state_id: item._id,
        dist_id: '',
        city_id: '',
      });

      // filter districts based on state

      this.districts = this.allDistricts.filter(
        (dist: any) => dist.state_id === item._id,
      );

      // reset city

      this.cities = [];this.filteredDistrict = this.allDistricts.filter(
(dist:any)=> dist.state_id === item.state_id
);


this.filteredCity=[];

      this.selectedDistrict = '';

      this.selectedCity = '';
    }

    if (type === 'district') {
      this.selectedDistrict = item.name_2;

      this.locationForm.patchValue({
        dist_id: item._id,
        city_id: '',
      });

      // filter cities based on district

      this.filteredCity = this.allCities.filter(
(city:any)=> city.id_2 === item.id_2
);

      this.selectedCity = '';
    }

    if (type === 'city') {
      this.selectedCity = item.city_nme;

      this.locationForm.patchValue({
        city_id: item._id,
      });
    }

    this.showLocationDropdown = '';
  }

  isNonReligious(): boolean {
    const name = (this.selectedReligion || '').toLowerCase();
    const id = String(this.religionForm.get('religion_id')?.value || '');
    return name.includes('non-relig') || name.includes('atheist') || name.includes('secular') || id === '66040275ccff8db6ddf8eecb';
  }

  updateAstrologyValidators() {
    const isNR = this.isNonReligious();
    const isHindu = !isNR && (this.selectedReligion || '').toLowerCase() === 'hindu';
    const casteCtrl = this.religionForm.get('caste_id');
    const subcasteCtrl = this.religionForm.get('sub_caste_id');
    const gothramCtrl = this.religionForm.get('gothrm_id');
    const doshamCtrl = this.religionForm.get('dosham');

    if (isNR) {
      casteCtrl?.clearValidators();
      subcasteCtrl?.clearValidators();
      gothramCtrl?.clearValidators();
      doshamCtrl?.clearValidators();
    } else {
      casteCtrl?.setValidators([Validators.required]);
      if (isHindu) {
        gothramCtrl?.setValidators([Validators.required]);
        doshamCtrl?.setValidators([Validators.required]);
      } else {
        gothramCtrl?.clearValidators();
        doshamCtrl?.clearValidators();
      }
    }

    casteCtrl?.updateValueAndValidity();
    subcasteCtrl?.updateValueAndValidity();
    gothramCtrl?.updateValueAndValidity();
    doshamCtrl?.updateValueAndValidity();
  }

  saveProfile() {
    const sessionToken = localStorage.getItem('sessionToken');
    const profileId = localStorage.getItem('profileId');

    if (!sessionToken || !profileId) return;

    if (this.basicForm.get('date_of_birth')?.hasError('underAge')) {
      Swal.fire(
        'Age Restriction',
        'You must be at least 18 years old. Please select a valid Date of Birth.',
        'warning'
      );
      return;
    }

    // Validate forms based on active tab or overall
    const forms = [
      this.basicForm,
      this.personalForm,
      this.professionalForm,
      this.religionForm,
      this.locationForm,
    ];
    const anyInvalid = forms.some((f) => f.invalid);

    if (anyInvalid) {
      Swal.fire(
        'Validation Error',
        'Please check all tabs and ensure all required fields are filled out.',
        'warning',
      );
      return;
    }

    const updatedData = {
      ...this.profileData,
      basic_info: { ...this.profileData.basic_info, ...this.basicForm.value },
      personal_info: {
        ...this.profileData.personal_info,
        ...this.personalForm.value,
        // preserve current gallery photo list so saveProfile doesn't overwrite recent uploads
        gallery_photos: this.galleryPhotos || this.profileData.personal_info?.gallery_photos || []
      },
      professional_info: {
        ...this.profileData.professional_info,
        ...this.professionalForm.value,
        additional_annual_income: this.professionalForm.value.additional_annual_income ? Number(this.professionalForm.value.additional_annual_income) : null,
      },
      religion_info: {
        ...this.profileData.religion_info,
        ...this.religionForm.value,
        caste_id: this.isNonReligious() ? null : this.religionForm.value.caste_id,
        sub_caste_id: this.isNonReligious() ? null : this.religionForm.value.sub_caste_id,
        gothrm_id: this.isNonReligious() ? null : (this.religionForm.value.gothrm_id || null),
        dosham: this.isNonReligious() ? 'Not Applicable' : (this.religionForm.value.dosham || null)
      },
      residing_location: {
        ...this.profileData.residing_location,
        ...this.locationForm.value,
      },
    };

    // Normalize empty-id strings to null to avoid Mongoose CastError (e.g. "")
    const normalizeIds = (obj: any) => {
      if (!obj || typeof obj !== 'object') return obj;
      Object.keys(obj).forEach(key => {
        const val = obj[key];
        if (val === '') {
          // Convert empty strings for id fields to null
          if (/_id$/.test(key) || key === 'natchr_id' || key === 'rasi_id') {
            obj[key] = null;
          }
        } else if (typeof val === 'object') {
          normalizeIds(val);
        }
      });
    };

    normalizeIds(updatedData);

    const payload = {
      action: 'edit',
      type: 'profile',
      profileId: profileId,
      data: updatedData,
    };

    this.loading = true;

    this.apiService.updateProfile(payload, sessionToken).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res.status === 'success') {
          Swal.fire({
            title: 'Success',
            text: 'Profile updated successfully!',
            icon: 'success',
            confirmButtonColor: '#a73453',
          });
          this.profileData = res.data;
        } else {
          Swal.fire('Error', res.data || 'Failed to update profile', 'error');
        }
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
        Swal.fire('Error', 'An error occurred while updating profile', 'error');
      },
    });
  }

  loadAvatarPreview() {
    const keycloakId = this.profileData?.basic_info?.keycloak_id || this.profileData?.basic_info?.ory_identity_id || localStorage.getItem('profileId');
    const avatarId = this.profileData?.personal_info?.avatar_Id;
    if (!keycloakId || !avatarId) {
      this.avatarPreview = this.defaultAvatarUrl;
      return;
    }

    const path = `${keycloakId}/gallery/avatar/${avatarId}`;
    this.apiService.getImageBase64(path).subscribe(res => {
      if (res && res.base64Image) {
        this.avatarPreview = `data:image/jpeg;base64,${res.base64Image}`;
      } else {
        this.avatarPreview = this.defaultAvatarUrl;
      }
    });
  }

  loadGalleryImages() {
    const keycloakId = this.profileData.basic_info?.keycloak_id || this.profileData.basic_info?.ory_identity_id || localStorage.getItem('profileId');
    this.galleryPhotos.forEach(photoName => {
      const path = `${keycloakId}/gallery/photos/${photoName}`;
      this.apiService.getImageBase64(path).subscribe(res => {
        if (res && res.base64Image) {
          this.galleryImagesBase64[photoName] = res.base64Image;
        }
      });
    });
  }

  onAvatarSelected(event: any) {
    const file = event.target.files?.[0];
    if (!file) return;

    this.selectedAvatarFile = file;
    const reader = new FileReader();
    reader.onload = () => {
      this.avatarPreview = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  uploadAvatar() {
    if (!this.selectedAvatarFile) {
      Swal.fire('No file selected', 'Please choose a profile photo first.', 'warning');
      return;
    }

    const profileId = localStorage.getItem('profileId');
    const sessionToken = localStorage.getItem('sessionToken');
    if (!profileId || !sessionToken) {
      Swal.fire('Session expired', 'Please login again.', 'warning');
      return;
    }

    this.loading = true;
    this.apiService.updateImage(this.selectedAvatarFile, sessionToken, profileId).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res?.status === 'success' || res?.data) {
          const avatarId = res?.data?.avatar_Id || res?.avatar_Id || this.selectedAvatarFile?.name;
          if (!this.profileData.personal_info) this.profileData.personal_info = {};
          this.profileData.personal_info.avatar_Id = avatarId;
          this.loadAvatarPreview();
          Swal.fire('Profile photo updated', 'Your profile picture has been updated successfully.', 'success');
        } else {
          Swal.fire('Error', res?.data || 'Failed to update profile photo.', 'error');
        }
      },
      error: () => {
        this.loading = false;
        Swal.fire('Error', 'Failed to upload profile photo.', 'error');
      }
    });
  }

  onGalleryFileSelected(event: any) {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;
    const profileId = localStorage.getItem('profileId');
    if (!profileId) return;

    if (this.galleryPhotos.length + files.length > 4) {
      Swal.fire('Limit Reached', 'You can upload a maximum of 4 additional gallery photos.', 'warning');
      return;
    }

    const fileArray = Array.from(files);
    this.loading = true;
    this.apiService.uploadGalleryPhotos(profileId, fileArray).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res.status === 'success') {
          Swal.fire('Uploaded!', 'Gallery photos added successfully.', 'success');
          this.galleryPhotos = res.data || [];
          // sync to profileData so subsequent saveProfile includes the new photos
          if (!this.profileData) this.profileData = {} as any;
          if (!this.profileData.personal_info) this.profileData.personal_info = {} as any;
          this.profileData.personal_info.gallery_photos = this.galleryPhotos;
          this.loadGalleryImages();
        } else {
          Swal.fire('Error', res.message || 'Upload failed', 'error');
        }
      },
      error: () => {
        this.loading = false;
        Swal.fire('Error', 'Failed to upload gallery photos.', 'error');
      }
    });
  }

  deleteGalleryPic(fileName: string) {
    const profileId = localStorage.getItem('profileId');
    if (!profileId) return;

    Swal.fire({
      title: 'Delete Photo?',
      text: 'Remove this photo from your gallery?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#800020'
    }).then(result => {
      if (result.isConfirmed) {
        this.apiService.deleteGalleryPhoto(profileId, fileName).subscribe({
          next: (res: any) => {
            if (res.status === 'success') {
              this.galleryPhotos = this.galleryPhotos.filter(p => p !== fileName);
              delete this.galleryImagesBase64[fileName];
              Swal.fire('Deleted!', 'Photo removed.', 'success');
            }
          }
        });
      }
    });
  }
}
